module.exports = __webpack_public_path__ + "build/img/good-news.4c5a2dbd.png";